enum AutomaticReportSendingStatus {
  InProgress = 0,
  SuccessfullySent = 1,
  Error = 2
}

export default AutomaticReportSendingStatus;
